var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 38,
    rx: 21.5,
    ry: 7,
    fill: "#D5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8839 9.11612C29.3957 8.62796 28.6043 8.62796 28.1161 9.11612L20.1612 17.0711C19.673 17.5592 19.673 18.3507 20.1612 18.8388C20.6493 19.327 21.4408 19.327 21.9289 18.8388L29 11.7678L36.0711 18.8388C36.5592 19.327 37.3507 19.327 37.8388 18.8388C38.327 18.3507 38.327 17.5592 37.8388 17.0711L29.8839 9.11612ZM30.25 42L30.25 10H27.75L27.75 42H30.25Z",
    fill: "#D5EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 9.29289C29.3166 8.90237 28.6834 8.90237 28.2929 9.29289L21.9289 15.6569C21.5384 16.0474 21.5384 16.6805 21.9289 17.0711C22.3195 17.4616 22.9526 17.4616 23.3431 17.0711L29 11.4142L34.6569 17.0711C35.0474 17.4616 35.6805 17.4616 36.0711 17.0711C36.4616 16.6805 36.4616 16.0474 36.0711 15.6569L29.7071 9.29289ZM30 42L30 10H28L28 42H30Z",
    fill: "#0593F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIconArrow);
export default __webpack_public_path__ + "static/media/tablet-icon_Arrow.71454c84d8d2479c56edf205e9ea1872.svg";
export { ForwardRef as ReactComponent };